import React, { Component, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Card, Spinner, Alert, FormControl, Container, Row, Col } from "react-bootstrap";
import storage from "utils/Storage";
import Carousel from "../../../pages/Parts/Home/crousel";
import { Helmet } from 'react-helmet';

import Slots from "../../../games/Slots/Slots";
import { API, BRAND, getBrand, isMobile } from 'utils/Helper';
import { withCookies } from 'react-cookie';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faSpinner } from '@fortawesome/free-solid-svg-icons';
import CustomSlider from "../../../components/CustomSlider";
import BannerGames from "../../../components/BannerGames";
import GameList from "../../../pages/HomeOrignals";
import { PickOption } from "../../../games/Lottery";
import CasinoLeaderboard from "../../../components/HelloGamesTable";
import { ChevronLeft, ChevronRight, Play, Spade, Trophy, Info } from "lucide-react";
import * as LucideIcons from "lucide-react";
import SwiperSlider from "../../../components/CustomSlider/SwiperSlider";
import sweet from "../../../assets/images/sweet.jpg";
import sugar from "../../../assets/images/sugar.jpg";

const HomeHeroSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
  width: 100%;

  @media (max-width: 768px) {
    margin-top: 40px !important;
  }

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 452px;
    gap: 32px;
    height: 220px;
    align-items: center;
  }
`;

const HeroLeft = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding: 0 8px;

  @media (min-width: 768px) {
    padding: 0;
  }
`;

const HeroTitle = styled.h1`
  font-size: 24px;
  font-weight: 900;
  line-height: 1.2;
  color: #ffffff;
  text-transform: uppercase;
  margin: 0;

  span {
    color: #559cfc;
  }

  @media (min-width: 768px) {
    font-size: 36px;
  }
`;

const HeroSubtitle = styled.p`
  margin-top: 12px;
  color: #b1bad3;
  font-size: 14px;
  font-weight: 500;
  max-width: 100%;
`;

const HeroActions = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 24px;
`;

const RegisterBtn = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  height: 40px;
  border-radius: 6px;
  background: #559cfc;
  color: #ffffff;
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  text-decoration: none;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(85, 156, 252, 0.2);

  &:hover {
    background: #357ae8;
    color: #ffffff;
    text-decoration: none;
  }
`;

const Divider = styled.div`
  height: 24px;
  width: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 0 4px;
`;

const SocialBtn = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: #0f212e;
  border: 1px solid rgba(255, 255, 255, 0.05);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
    background: #2f4553;
  }
`;

const SocialIconSpan = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 900;
`;

const HeroRight = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  width: 100%;
  flex-shrink: 0;

  @media (min-width: 768px) {
    height: 220px;
  }
`;

const CategoryCard = styled(Link)`
  position: relative;
  border-radius: 8px;
  height: 140px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  text-decoration: none;
  display: block;

  @media (min-width: 768px) {
    height: 100%;
  }

  &:hover {
    text-decoration: none;
  }
`;

const CardImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s;

  ${CategoryCard}:hover & {
    transform: scale(1.1);
  }
`;

const CardOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.2) 60%, transparent 100%);
`;

const CardFooter = styled.div`
  position: absolute;
  bottom: 12px;
  left: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  font-weight: bold;
  z-index: 10;
`;

const CardTitle = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`;

const CardCount = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
`;

const LiveDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1f935f;
  box-shadow: 0 0 8px #1f935f;
`;
// import 'swiper/swiper-bundle.min.css';
import 'swiper/css';  // Default Swiper styles
import 'swiper/css/navigation'; // If you need navigation styles
import 'swiper/css/pagination'; // If you need pagination styles




// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/swiper-bundle.min.css';
import 'swiper/css';  // Default Swiper styles
// import 'swiper/css/navigation'; // If you need navigation styles
// import 'swiper/css/pagination'; // If you need pagination styles
import { Autoplay, Thumbs, Mousewheel, Pagination, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.css'; // Ensure you import Swiper styles
import { FaPlay } from "react-icons/fa";

import UpcomingLottery, { UpcomingLottry } from "../../../games/Lottery/UpcomingLottery"
import BannerSlider from "../../../components/BannerSlider";
import DynamicDeposit from "../../../pages/Payment/DynamicDeposit";
import { fetchGameList, fetchGameListNew } from "api/gameApi";
import { useGameLaunchMutation, useGameLaunchNewMutation } from "hooks/useGame";
import { useActiveGroups } from "hooks/useGameEngine";
import { useMyProfileQuery, useLevelQuery } from "hooks/useUser";
import DynamicGroupSwiper from "../../../components/DynamicGroupSwiper";


const NewCarousel = styled.div`

display:none;
@media(max-width:968px){
display:block;
}
`;

const FullScreenContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: #1b2336;
`;

const FullScreenIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  display: ${(props) => (props.loading ? 'none' : 'block')};
`;
// const ResponsiveImage = styled.img`
//   object-fit: cover;
//   width: 140px;
//   height: 140px;
//   border-radius:20px;

//   @media (min-width: 467px) {
//     width: 188px;
//     height: 188px;
//   }
// `;

const ResponsiveImage = styled.img`
  object-fit: cover;
  width: 100%;  // Adjusts image width to fill the container
  height: auto; // Maintains aspect ratio for responsiveness


 

  @media (min-width: 467px) {
    width: 100%;
    height: auto;
    
  }
`;


const ResponsiveImage1 = styled.img`
  object-fit: cover;
  width: 150px;  // Adjusts image width to fill the container
  height: auto; // Maintains aspect ratio for responsiveness
  // border-radius: 20px;
  @media (min-width: 467px) {
    width: 188px;
    height: auto;
    border-radius: 20px;
  }
`;

const BackButton = styled.button`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
  background: none;
  border: none;
  color: #000;
  font-size: 24px;
  cursor: pointer;
`;
const Loader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: #000;
`;





const SliderContainer = styled.div`
  width: 100%;
  max-width: 800px;
  position: relative;
  overflow: hidden;
`;

const SliderTrack = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: translateX(${(props) => props.translateX}%);
`;

const SliderItem = styled.div`
  flex: 0 0 100%;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
  background-color: #f2f2f2;
`;

const SliderNavigation = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
`;

const NavigationButton = styled.button`
  background-color: rgba(255, 255, 255, 0.5);
  border: none;
  outline: none;
  font-size: 24px;
  padding: 10px;
  cursor: pointer;
`;
const LottoCard = styled.button`
  background-color: #0E1423;
 border-radius:12px;
 width:100%
   margin-bottom:12px;
`;

const ContainerPlay = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  
  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    // padding: 10px;
    justify-content: center;
  }

  @media (max-width: 767px) {
    gap: 8px;
    // padding: 5px;
  }
`;

const PickOptionWrapper = styled.div`
  flex: 0 0 auto;
  width: calc(50% - 6px);
  scroll-snap-align: start;

  @media (min-width: 768px) {
    width: 100%;
  }
`;


const HiddenOnSmallScreens = styled.div`
display:flex;
  @media (max-width: 768px) {
    display: none;
  }
`;

const GamesWrapper = styled.div`
  background-color: transparent;
  padding: 0px;
  border-radius: 15px;  
  position: relative;
  margin-top: 10px !important;
  overflow:hidden;
`;

const SlotImages = styled.img`
width: 100%;
  min-width:60px; 
  min-height:70px;
  height: auto;
  border-radius: 8px;

  @media(max-width:400px){
  min-width:50px; 
  min-height:60px;
  }
`;

const GridItemSlots = styled.div`
 background-color: transparent;
border-radius: 10px;
width: 60px;
box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
transition: transform 0.3s ease;
display: flex;
overflow: hidden; 
height: auto; 

@media(max-width:400px){
width:50px;
  }
`

const GamesTopWrapper = styled.div`
  //   background-color: #1c1e22;
  //   padding: 2px;
  border-radius: 0 20px 20px 20px; /* top-left | top-right | bottom-right | bottom-left */
  position: relative;
  margin-top: 40px !important;
  background-color: transparent;
  @media (max-width: 768px) {
    margin-top: 50px !important;
  }
`;
const GamesSlotWrapper = styled.div`
  // background-color: #1C1E22;
  padding: 2px;
  border-radius: 0 20px 20px 20px; /* top-left | top-right | bottom-right | bottom-left */
  position: relative;
  margin-top: 10px !important;
  //  margin-top: 100px !important;
  // @media (max-width: 768px) {
  //   margin-top: 100px !important;
  // }
`;

// const GridContainer = styled.div`
//   display: grid;
//   gap: 10px;
//   padding: 0rem;
//   margin:12px 12px;
//   width: 100%;
//   // Mobile view (2 columns)
//   grid-template-columns: repeat(2, 1fr);
//   // Tablet view (3 columns)
//   @media (min-width: 768px) {
//     grid-template-columns: repeat(3, 1fr);
//   }
//   // Desktop view (4 columns)
//   @media (min-width: 1024px) {
//     grid-template-columns: repeat(6, 1fr);
//   }
// `;
// const GridItem = styled.div`
//   // background-color: transparent;
//   background-color:green;
//   width:100%;
//   border-radius: 10px;
//   // overflow: hidden;
//   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//   transition: transform 0.3s ease;
//   &:hover {
//     transform: translateY(-5px);
//   }
// `;


const GridContainer = styled.div`
  display: grid;
  gap: 10px;
  padding: 1rem;
  // margin: 12px 12px;
  width: 100%;
  

  // // Mobile view (2 columns)
  // grid-template-columns: repeat(2, 1fr);

  // // Tablet view (3 columns)
  // @media (min-width: 768px) {
  //   grid-template-columns: repeat(3, 1fr);
  // }

  // // Medium Desktop view (4 columns)
  // @media (min-width: 1024px) {
  //   grid-template-columns: repeat(4, 1fr);
  // }

  // // Larger Desktop view (6 columns)
  // @media (min-width: 1440px) {
  //   grid-template-columns: repeat(6, 1fr);
  // }

  // Mobile view (1 columns)
  grid-template-columns: repeat(1, 1fr);

   // Tablet view (2 columns)
  @media (min-width: 340px) {
    grid-template-columns: repeat(2, 1fr);
  }

  // Tablet view (3 columns)
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }

  // Desktop view (4 columns)
  @media (min-width: 1024px) {
    grid-template-columns: repeat(5, 1fr);
  }

  // Large Desktop view (6 columns)
  @media (min-width: 1440px) {
    grid-template-columns: repeat(6, 1fr);
  }
`;

const GridContainerHouse = styled.div`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  text-align: start;
  gap: 20px;
  justify-content: start !important;
  overflow: hidden;  
  position: relative; 

  &::-webkit-scrollbar {
    display: none;
  }
 

  }
`;

const GridItem = styled.div`
  background-color: transparent;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative; /* Needed for the play icon */
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;

  /* For image */
  .swiper-slide-img {
    transition: opacity 0.3s ease; /* Smooth transition for image opacity */
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.4); /* Background color on hover */
  }

  &:hover .swiper-slide-img {
    opacity: 0.3; /* Reduce opacity of the image on hover */
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px; /* Adjust icon size */
    color: white;
    opacity: 0;
   
    padding:13px;
    justify-item:center;
    text-align:center;
    background-color:#0009;
    border-radius:100%;
    transition: opacity 0.3s ease;
  }

  &:hover .play-icon {
    opacity: 1; /* Show play icon on hover */
  }
    
`;


const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 160px; /* Ensure it matches the image size */
  overflow: hidden;
  border-radius: 10px;

  /* Hover overlay effect */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0); /* No overlay initially */
    transition: background 0.3s ease;
    pointer-events: none; /* Allow pointer events to pass through */
  }

  /* Darker overlay on hover */
  &:hover::before {
    background: rgba(0, 0, 0, 0.4);
  }

  /* Image style inside the wrapper */
  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    border-radius: 10px;
  }
`;




// const GridContainerNew = styled.div`
//   display: grid;
//   gap: 10px;
//   background-color:red;
//   border-radius:0 20px 20px 20px;
//   padding:2rem 2rem;
//   // margin:12px 12px;
//   width: 100%;
//   padding-right:17px;
//   // Mobile view (2 columns)
//   grid-template-columns: repeat(2, 1fr) !important;
//   // Tablet view (3 columns)
//   @media (min-width: 768px) {
//     grid-template-columns: repeat(3, 1fr) !important;
//   }
//   // Desktop view (4 columns)
//   @media (min-width: 1024px) {
//     grid-template-columns: repeat(6, 1fr) !important;
//   }
// `;
const GridContainerNew = styled.div`
  // display: grid;
  gap: 5px;
  // border:2px solid pink; 
  // border-radius: 0 20px 20px 20px;
  width: 100%;
  height:100%;
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  //  grid-template-columns: repeat(7, minmax(200px, 1fr));
  // grid-gap: 10px; 
  // padding-right: 17px;
  // overflow-x: auto; /* Enables horizontal scrolling */
  // white-space: nowrap; /* Prevents line breaks, so content stays in a single line */
  // Mobile view (1 columns)
  // grid-template-columns: repeat(7, 1fr); /* Creates 3 equal columns */
  // grid-template-rows: 1fr; /* Only one row */

   // Tablet view (2 columns)
  // @media (min-width: 340px) {
  //   grid-template-columns: repeat(2, 1fr);
  // }

  // Tablet view (3 columns)
  // @media (min-width: 768px) {
  //   grid-template-columns: repeat(3, 1fr);
  // }

  // Desktop view (4 columns)
  // @media (min-width: 1024px) {
  //   grid-template-columns: repeat(5, 1fr);
  // }

  // Large Desktop view (6 columns)
  // @media (min-width: 1440px) {
  //   grid-template-columns: repeat(6, 1fr);
  // }
`;

const GridItemNew = styled.div`
  background-color: transparent;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  &:hover {
    transform: translateY(-5px);
  }
`;




const NavWrapper = styled.div`
  width: 100%;
  margin-bottom: 8px;
  margin-top:24px;
  overflow: hidden;
  display:flex;
  justify-content:space-between;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const Title = styled.h3`
  padding: 10px;
  margin: 0;
  font-size: 10px;
  text-align: left;
  color: rgb(152, 167, 181);
  line-height:20px;
`;
const TopTitleContainer = styled.h3`
  background-color: #1C1E22;
  border-radius: 15px;
  position: absolute;
  top: -71px;
  left: 0;
  z-index: 1;
  padding: 10px;
  margin: 0;
`;

const AllButtonRigthTitleContainer = styled.div`
  position: absolute;
  display: flex;
  gap: 10px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  top: -44px; //vivek
  // right: 0;
  color: #7f898c;
  font-weight: bold;
  z-index: 1;
  margin: 0;
`;


const AllButtonTopTitleContainer = styled.div`
  background-color: #1C1E22;
  border-radius: 15px;
  display:flex;
  justify-caontent:center;
  align-items:center;
  color:#7F898C;
  font-weight:bold;
  z-index: 1;
  padding: 5px 20px;
  margin: 0;
  cursor:pointer;

  @media (max-width: 350px) {
    display:none;
  }

  
`;
const PaginationButton = styled.div`
  background-color: #1C1E22;
  border-radius: 50%;
  display:flex;
  justify-content:center;
  align-items:center;
  color:#7F898C;
  font-weight:bold;
  z-index: 1;
  padding: 5px;

`;
const PaginationButtonLottery = styled.div`
  // background-color: #1C1E22;
  border-radius: 50%;
  display:flex;
  justify-content:center;
  align-items:center;
  color:#7F898C;
  font-weight:bold;
  z-index: 1;
  padding: 5px;
  

`;


// const AllButtonRigthTitleContainer = styled.div`
//   position: absolute;
//   display: block;
//   justify:center;
//   gap: 2rem; /* Use relative units for spacing */
//   align-items: center;
//   top: 0rem; /* Adjust using rems */
//   right: 0;
//   color: #7F898C;
//   font-weight: bold;
//   z-index: 1;
//   margin: 0;

//   @media (max-width: 768px) {
//     gap: 0.5rem; /* Reduce gap on smaller screens */
//     top: -4.5rem; /* Adjust positioning for smaller screens */
//   }
// `;

// const AllButtonTopTitleContainer = styled.div`
//   background-color: #1C1E22;
//   border-radius: 15px;
//   display: flex;
//   justify-content: center; /* Corrected spelling */
//   align-items: center;
//   color: #7F898C;
//   font-weight: bold;
//   z-index: 1;
//   padding: 0.5rem 1.5rem; /* Use relative padding */
//   margin: 0;
//   cursor: pointer;
//   font-size: 1rem; /* Base font size */

//   @media (max-width: 768px) {
//     padding: 0.25rem 1rem; /* Adjust padding on smaller screens */
//     font-size: 0.875rem; /* Slightly smaller font on small screens */
//   }
// `;

// const PaginationButton = styled.div`
//   background-color: #1C1E22;
//   border-radius: 50%;
//   display: flex;
//   justify-content: center; /* Corrected spelling */
//   align-items: center;
//   color: #7F898C;
//   font-weight: bold;
//   z-index: 1;
//   padding: 0.5rem; /* Use relative padding */
//   font-size: 1rem; /* Base font size */

//   @media (max-width: 768px) {
//     padding: 0.375rem; /* Smaller padding on small screens */
//     font-size: 0.875rem; /* Adjust font size for small screens */
//   }
// `;



const ProviderGridContainer = styled.div.attrs({ className: 'provide-grid-container' })`
  display: grid;
  gap: 1px;
  background-color: #1e2124;
  padding: 1px;
  border-radius: 10px;
  overflow: hidden;

  // Mobile layout (3 columns)
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 1fr;

  // Tablet layout (3 columns)
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }

  // Desktop layout (9 columns, 2 rows)
  @media (min-width: 1024px) {
    grid-template-columns: repeat(9, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }
`;

const ProviderGridItem = styled.div.attrs({ className: 'provide-grid-item' })`
  background-color: #313439;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 8px;

  // Maintain aspect ratio on mobile and tablet
  @media (max-width: 1023px) {
    aspect-ratio: 16 / 9;
  }
`;

const ProviderLogo = styled.img`
object-fit:contain;
height:1.6rem;
width:80%;
`;


const ProviderWrapper = styled.div`
margin-top:50px !important;
margin-bottom:50px !important;
`;

const ProviderHeadingWrapper = styled.div`
margin-top:10px !important;
margin-bottom:10px !important;
display:flex;
justify-content:space-between;
`;



// const NavBar = styled.div`
//   display: flex;
//   justify-content: flex-end;
//   width: 100%;
// `;

// const NavBarEnd = styled.div`
//   background-color: #191A1E;
//   padding: 2px;
//   display: flex;
//   gap: 5px;
//   border-radius: 24px;
//   overflow-x: auto;
//   width:60% !important;
//   // flex:1 1;
//   white-space: nowrap;
//   -webkit-overflow-scrolling: touch;
//   scrollbar-width: none;
//   -ms-overflow-style: none;

//   &::-webkit-scrollbar {
//     display: none;
//   }

//   @media (max-width: 768px) {
//     // max-width: 100%;
//   }
// `;

const NavItem = styled.button`
  display: flex;
  align-items: center;
  background-color: ${props => props.active ? '#23262B' : 'transparent'};
  color: ${props => props.active ? '#ffffff' : '#888888'};
  border: none;
  padding: 12px 16px;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 12px;
  white-space: nowrap;
  flex-shrink: 0;
 

  &:hover {
    background-color: #2a2a2a;
  }
`;




const NavBar = styled.nav`
  display: inline-flex; 
  width:100%;
  // justify-content: flex-end;
  // background-color: #191A1E;
  // padding: 4px;
  // border-radius: 26px;
  // overflow: hidden; 
`;

const NavBarEnd = styled.div`
  display: flex;
  width: 100%;
  align-items:center;
  gap:10px;
`;

const TabSwitcher = styled.div`
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Tab = styled.button`
  background-color:transparent;
  color: #828B8D;
  border: none;
  // padding: 10px 20px;
  // border-radius: 26px;
  font-weight:600;
  cursor: pointer;
  font-size: 12px;
  // margin-right: 10px;
  white-space: nowrap;
  // transition: background-color 0.3s ease;
  // &:hover {
  //   background-color: ${props => props.active ? '#2c3137' : '#1c1e22'};
  // }
`;

const FlexArrange = styled.div`
  display: flex;
  align-items: center;
`;

const TabImage = styled.img`
  height: 28px;
  width: 28px;
  object-fit: contain;
  margin-right: 8px;
  filter: ${props => props.active ? 'none' : 'grayscale(100%)'};
  transition: filter 0.3s ease;
`;

const TabText = styled.div`
  @media (max-width: 480px) {
  font-size:clamp(5px,3vw,14px);
  }
`;

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      banners: [],
      showVipInfo: false,
      padding: 'py-2',
      selectedSection: 'home',
      sectionIndex: 0,
      slideSelected: null,
      gamesEvolution: [],
      gamesPragmatic: [],
      gamesPragmaticlive: [],
      gamesEvoplay: [],
      gamesGenisis: [],
      gamesPgsoft: [],
      gamesLiveCasinoProvider: [],
      gamesSpribe: [],
      gamesSports: [],
      gamesMostExpensive: [],
      error: null,
      loading: false,
      showAll: false,
      message: null,
      showMore: false,
      showMoreP: false,
      showMoreO: false,
      showMoreLCP: false,
      showMoreSP: false,
      showMoreSB: false,
      isMobileView: window.innerWidth <= 768,
      searchQuery: '',
      showIframe: false,
      iframeUrl: '',
      iframeLoading: true,
      showAll: false,
      showAllData: false,

      activeItem: 'Lobby',
      authConfig: null
    };
    this.swiperRef3 = React.createRef();
    this.swiperRef2 = React.createRef();
    this.swiperRef1 = React.createRef();
    this.swiperRef = React.createRef();
    this.sections = ["/assets/images/evolutionicon.png", "/assets/images/ezubi.png", "/assets/images/pragmatic.png", "/assets/images/netent.png", "/assets/images/novomatic.png"];
    this.livecasino = ["/assets/images/live1.png", "/assets/images/live2.png", "/assets/images/live3.jpg", "/assets/images/live4.jpg", "/assets/images/live5.jpg", "/assets/images/live6.png"];
    this.itemsToShow = 5;
    this.containerPlayRef = React.createRef();
    this.vipInfoRef = React.createRef();
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
  }

  // Toggle showAll state
  handleShowAllClick = () => {
    this.setState(prevState => ({
      showAll: !prevState.showAll
    }));
  };

  // Handle game launch (example function)
  handleGameLaunch = (gameCode, providerCode) => {
    console.log(`Launching game with code ${gameCode} and provider ${providerCode}`);
  };

  // Navigate to the previous slide
  handlePrevClick = () => {
    if (this.swiperRef.current) {
      this.swiperRef.current.swiper.slidePrev();
    }
  };

  // Navigate to the next slide
  handleNextClick = () => {
    if (this.swiperRef.current) {
      this.swiperRef.current.swiper.slideNext();
    }
  };
  // Custom method for next slide
  nextSlideHandler = () => {
    if (this.swiperRef1.current && this.swiperRef1.current.swiper) {
      this.swiperRef1.current.swiper.slideNext();
    }
  };

  // Custom method for previous slide
  prevSlideHandler = () => {
    if (this.swiperRef1.current && this.swiperRef1.current.swiper) {
      this.swiperRef1.current.swiper.slidePrev();
    }
  };
  // Custom method for next slide
  nextSlideHandler2 = () => {
    if (this.swiperRef2.current && this.swiperRef2.current.swiper) {
      this.swiperRef2.current.swiper.slideNext();
    }
  };

  // Custom method for previous slide
  prevSlideHandler2 = () => {
    if (this.swiperRef2.current && this.swiperRef2.current.swiper) {
      this.swiperRef2.current.swiper.slidePrev();
    }
  };
  // Custom method for next slide
  nextSlideHandler3 = () => {
    if (this.swiperRef3.current && this.swiperRef3.current.swiper) {
      this.swiperRef3.current.swiper.slideNext();
    }
  };

  // Custom method for previous slide
  prevSlideHandler3 = () => {
    if (this.swiperRef3.current && this.swiperRef3.current.swiper) {
      this.swiperRef3.current.swiper.slidePrev();
    }
  };

  handleShowAllData = () => {
    this.setState(prevState => ({ showAllData: !prevState.showAllData }));
  }

  handleMouseDown(e) {
    this.isDown = true;
    this.startX = e.pageX - this.containerPlayRef.current.offsetLeft;
    this.scrollLeft = this.containerPlayRef.current.scrollLeft;
  }

  handleShowAllClick = (e) => {
    e.preventDefault(); // Prevent default link behavior
    this.setState({ showAll: !this.state.showAll });
  }


  handleMouseLeave() {
    this.isDown = false;
  }

  handleMouseUp() {
    this.isDown = false;
  }

  handleMouseMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.containerPlayRef.current.offsetLeft;
    const walk = (x - this.startX) * 2;
    this.containerPlayRef.current.scrollLeft = this.scrollLeft - walk;
  }
  handleItemClick = (item) => {
    this.setState({ activeItem: item });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activeItem !== this.state.activeItem) {
      console.log(`Active item changed to: ${this.state.activeItem}`);
      // Add any additional side effects or logic you want to run on activeItem change
    }
  }

  handleClickOutside = (event) => {
    if (this.vipInfoRef && this.vipInfoRef.current && !this.vipInfoRef.current.contains(event.target)) {
      this.setState({ showVipInfo: false });
    }
  };

  fetchBanners = async () => {
    try {
      const res = await fetch(`${API}/website-banners?type=home&theme=stake`);
      const json = await res.json();
      if (json && json.success) {
        this.setState({ banners: json.data || [] });
      }
    } catch (err) {
      console.error('Failed to fetch home banners:', err);
    }
  }

  handleGameLaunch = async (gameCode, provider) => {
    this.setState({ loading: true, message: null });
    try {
      const { cookies } = this.props;
      const uid = cookies.get('uid');

      if (!uid) {
        throw new Error("Please login to play live game");
      }

      const result = await this.props.launchGame({
        user_code: String(uid),
        provider_code: provider,
        game_code: gameCode
      });

      if (result.status === 1) {
        this.setState({ iframeUrl: result.launch_url, showIframe: true, iframeLoading: true });
      } else if (result.status === 0 && result.detail === "user_code is not allowed to be empty") {
        throw new Error("Please login to play live game");
      } else {
        throw new Error("Failed to launch game: " + result.msg);
      }
    } catch (error) {
      this.setState({ message: { type: 'error', text: error.message } });
    } finally {
      this.setState({ loading: false });
      setTimeout(() => {
        this.setState({ message: null });
      }, 5000);
    }
  };

  handleGameLaunchNew = async (gameCode, provider) => {
    this.setState({ loading: true, message: null });
    try {
      const { cookies } = this.props;
      const uid = cookies.get('uid');
      if (!uid) {
        throw new Error("Please login to play live game");
      }

      const result = await this.props.launchGameNew({
        user_code: String(uid),
        game_code: gameCode
      });

      if (result.status === "success" && result.content && result.content.game && result.content.game.url) {
        this.setState({ iframeUrl: result.content.game.url, showIframe: true, iframeLoading: true });
      } else if (result.status === "fail" && result.detail === "user_code is not allowed to be empty") {
        throw new Error("Please login to play live game");
      } else {
        throw new Error("Failed to launch game: " + result.error);
      }
    } catch (error) {
      this.setState({ message: { type: 'error', text: error.message } });
    } finally {
      this.setState({ loading: false });
      setTimeout(() => {
        this.setState({ message: null });
      }, 5000);
    }
  };

  handleBackButton = () => {
    this.setState({ showIframe: false, iframeUrl: '', iframeLoading: true });
    window.location.href = "/";
  };

  handleIframeLoad = () => {
    this.setState({ iframeLoading: false });
  };

  componentDidMount() {
    this._isMounted = true;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    if (isMobile()) {
      this.setState({ padding: 'p-1' });
    }

    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    const containerPlay = this.containerPlayRef.current;
    if (containerPlay) {
      containerPlay.addEventListener('mousedown', this.handleMouseDown);
      containerPlay.addEventListener('mouseleave', this.handleMouseLeave);
      containerPlay.addEventListener('mouseup', this.handleMouseUp);
      containerPlay.addEventListener('mousemove', this.handleMouseMove);
    }
    document.addEventListener('mousedown', this.handleClickOutside);

    this.fetchBanners();
    fetch(`${API}/api/auth/requirements?type=login`)
      .then(res => res.json())
      .then(json => {
        if (json.status && json.data) {
          this.setState({ authConfig: json.data.fields_config || json.data });
        }
      })
      .catch(err => console.error("Failed to fetch auth requirements on Home:", err));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    this._isMounted = false;

    const containerPlay = this.containerPlayRef.current;
    if (containerPlay) {
      containerPlay.removeEventListener('mousedown', this.handleMouseDown);
      containerPlay.removeEventListener('mouseleave', this.handleMouseLeave);
      containerPlay.removeEventListener('mouseup', this.handleMouseUp);
      containerPlay.removeEventListener('mousemove', this.handleMouseMove);
    }
    document.removeEventListener('mousedown', this.handleClickOutside);
  }


  fetchGames = async (provider) => {
    try {
      const games = await fetchGameList(provider);
      return games;
    } catch (error) {
      console.error("Failed to fetch data:", error.message);
      return [];
    }
  };

  fetchGamesNew = async (provider) => {
    try {
      const games = await fetchGameListNew(provider);
      return games;
    } catch (error) {
      console.error("Failed to fetch data:", error.message);
      return [];
    }
  };

  handleResize = () => {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.setState({ isMobileView: width <= 768 });
  };

  handleClick = (e) => {
    this.setState({ selectedSection: e });
  };

  handleArrowClick = (direction) => {
    const { sectionIndex } = this.state;
    const { sections, itemsToShow } = this;
    const totalSections = sections.length;

    let newIndex;

    if (direction === 'left') {
      newIndex = (sectionIndex - itemsToShow + totalSections) % totalSections;
    } else {
      newIndex = (sectionIndex + itemsToShow) % totalSections;
    }

    this.setState({ selectedSection: sections[newIndex], sectionIndex: newIndex });
  };

  handleShowMore = () => {
    this.setState({ showMore: !this.state.showMore });
  };

  handleShowMoreP = () => {
    this.setState({ showMoreP: !this.state.showMoreP });
  };

  handleShowMoreO = () => {
    this.setState({ showMoreO: !this.state.showMoreO });
  };

  handleShowMoreLCP = () => {
    this.setState({ showMoreLCP: !this.state.showMoreLCP });
  };

  handleShowMoreSP = () => {
    this.setState({ showMoreSP: !this.state.showMoreSP });
  };

  handleShowMoreSB = () => {
    this.setState({ showMoreSB: !this.state.showMoreSB });
  };

  handleSearch = (query) => {
    this.setState({ searchQuery: query });
  };

  getFilteredGames = (games) => {
    const { searchQuery } = this.state;
    if (!searchQuery) return games;
    return games.filter(game => game.game_name && game.game_name.toLowerCase().includes(searchQuery.toLowerCase()));
  };


  render() {

    let { content, t } = this.props;
    const isAuthed = storage.getKey("logged") ? true : false;
    const { activeItem } = this.state;
    const { showAll } = this.state;

    const { selectedSection, sectionIndex, slideSelected, gamesEvolution, gamesLiveCasinoProvider, gamesSpribe, gamesPragmatic, gamesPragmaticlive, gamesSports, gamesEvoplay, gamesGenisis, gamesPgsoft, gamesMostExpensive, loading, message, searchQuery, showMore, showMoreP, showMoreO, showMoreLCP, showMoreSP, showMoreSB, isMobileView, padding, showIframe, iframeUrl, iframeLoading } = this.state;
    const { sections, itemsToShow, livecasino } = this;
    const tabs = [
      { name: 'Lobby', image: '/assets/images/hellogames/lobby.webp' },
      { name: 'Original', image: '/assets/images/hellogames/originalcasino.webp' },
      // { name: 'Slots', image: '/assets/images/hellogames/slots.webp' },
      // { name: 'Live Casino', image: '/assets/images/hellogames/livecasino.webp' },
    ];
    const companies = [
      '/assets/images/Providers/evolutiongaming.webp', '/assets/images/Providers/netent.webp', '/assets/images/Providers/bet.webp', '/assets/images/Providers/quickspin.webp', '/assets/images/Providers/gameart.webp', '/assets/images/Providers/playstone.webp',
      '/assets/images/Providers/bgaming.webp', '/assets/images/Providers/ka.webp', '/assets/images/Providers/wazdan.webp', '/assets/images/Providers/spinn.webp', '/assets/images/Providers/evoplay.webp', '/assets/images/Providers/thunder.webp',
      '/assets/images/Providers/endrophina.webp', '/assets/images/Providers/bgaming.webp', '/assets/images/Providers/habanero.webp', '/assets/images/Providers/becom.webp', '/assets/images/Providers/platipus.webp', '/assets/images/Providers/tomhron.webp'
    ];


    const visibleSections = sections.slice(sectionIndex, sectionIndex + itemsToShow);

    const filteredGamesEvolution = this.getFilteredGames(gamesEvolution);
    const filteredGamesPragmatic = this.getFilteredGames(gamesPragmatic);
    const { showAllData } = this.state;

    const filteredGamesEvoplay = this.getFilteredGames(gamesEvoplay);
    const filteredGamesGenisis = this.getFilteredGames(gamesGenisis);
    const filteredGamesPgsoft = this.getFilteredGames(gamesPgsoft);

    const displayGamesEvoplay = showAllData ? filteredGamesEvoplay : filteredGamesEvoplay.slice(0, 6);
    const displayGamesGenisis = showAllData ? filteredGamesGenisis : filteredGamesGenisis.slice(0, 6);
    const displayGamesPgsoft = showAllData ? filteredGamesPgsoft : filteredGamesPgsoft.slice(0, 6);



    const filteredSpribe = this.getFilteredGames(gamesSpribe);
    const filteredSports = this.getFilteredGames(gamesSports);
    const filtergamespragamaticlive = this.getFilteredGames(gamesPragmaticlive);
    const filtergamesLiveCasinoProvider = this.getFilteredGames(gamesLiveCasinoProvider);
    const displayedGames = isMobileView ? gamesEvolution : (showMore ? gamesEvolution : gamesEvolution.slice(0, 5));
    const displayedGamesSP = isMobileView ? gamesSpribe : (showMoreSP ? gamesSpribe : gamesSpribe.slice(0, 5));
    const displayedGamesSB = isMobileView ? gamesSports : (showMoreSB ? gamesSports : gamesSports.slice(0, 5));
    const displayedGamesLCP = isMobileView ? gamesLiveCasinoProvider : (showMoreLCP ? gamesLiveCasinoProvider : gamesLiveCasinoProvider.slice(0, 5));
    const displayGamesP = isMobileView ? gamesPragmatic : (showMoreP ? gamesPragmatic : gamesPragmatic.slice(0, 5));
    const displayGamesPL = isMobileView ? gamesPragmaticlive : (showAll ? gamesPragmaticlive : gamesPragmaticlive.slice(0, 12));


    console.log("display", displayGamesPL)


    console.log("image url", displayGamesPL)


    const imageStyle = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '250px',
      animation: 'fadeinout 2s infinite',
    };
    const animationStyle = `
      @keyframes fadeinout {
        0%, 100% { opacity: 0; }
        50% { opacity: 1; }
      }
    `;
    if (showIframe) {
      return (
        <FullScreenContainer>
          <style>{animationStyle}</style>
          {this.state.iframeLoading && (
            <img src="assets/images/lg.png" alt="Loading" style={imageStyle} />
          )}
          <FullScreenIframe
            src={iframeUrl}
            title="Game Iframe"
            onLoad={this.handleIframeLoad}
            loading={this.state.iframeLoading}
          />
          <BackButton style={{ color: "white" }} onClick={this.handleBackButton}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </BackButton>
        </FullScreenContainer>
      );
    }


    const items = [
      { imageUrl: 'https://example.com/image1.jpg', title: 'Slide 1' },
      { imageUrl: 'https://example.com/image2.jpg', title: 'Slide 2' },
      { imageUrl: 'https://example.com/image3.jpg', title: 'Slide 3' },
      { imageUrl: 'https://example.com/image4.jpg', title: 'Slide 4' },
      { imageUrl: 'https://example.com/image5.jpg', title: 'Slide 5' },
    ];

    const games = [{
      "id": "crash",
      "title": "CRASH",

      "description": "Lower risk, Higher reward",
      "multiplier": "999x",
      "imageUrl": "/assets/images/hellogames/hello1.webp"
    },
    {
      "id": "crash-trenball",
      "title": "CRASH TRENBALL",

      "description": "",
      "imageUrl": "/assets/images/hellogames/hello2.webp"
    },
    {
      "id": "mine",
      "title": "MINE",
      "description": "",

      "imageUrl": "/assets/images/hellogames/hello3.webp"
    },
    {
      "id": "ultimate-dice",
      "title": "ULTIMATE DICE",

      "description": "",
      "multiplier": "9900x",
      "imageUrl": "/assets/images/hellogames/hello4.webp"
    },
    {
      "id": "oriental-beauties",
      "title": "ORIENTAL BEAUTIES",
      "description": "",
      "imageUrl": "/assets/images/hellogames/hello1.webp"
    },
    {
      "id": "classic-dice",
      "title": "CLASSIC DICE",
      "description": "Easy to win like a real casino",
      "imageUrl": "/assets/images/hellogames/hello2.webp"
    },
    {
      "id": "plinko",
      "title": "PLINKO",
      "description": "",
      "multipliers": ["2.1x", "0.5x", "420x"],
      "imageUrl": "/assets/images/hellogames/hello3.webp"
    },
    {
      "id": "cave-of-plunder",
      "title": "CAVE OF PLUNDER",
      "description": "",
      "imageUrl": "/assets/images/hellogames/hello4.webp"
    },
    {
      "id": "wheel",
      "title": "WHEEL",
      "description": "",
      "multipliers": ["39.6x", "49.50x", "19.8x"],
      "imageUrl": "/assets/images/hellogames/hello1.webp"
    },
    {
      "id": "saviour-sword",
      "title": "SAVIOUR SWORD",
      "description": "",
      "imageUrl": "/assets/images/hellogames/hello2.webp"
    },
    {
      "id": "mine",
      "title": "MINE",
      "description": "",
      "imageUrl": "/assets/images/hellogames/hello3.webp"
    },
    {
      "id": "ultimate-dice",
      "title": "ULTIMATE DICE",
      "description": "",
      "multiplier": "9900x",
      "imageUrl": "/assets/images/hellogames/hello4.webp"
    },
    ]

    const BCoriginal = [

      //   {
      //   "id": "crash",
      //   "title": "CRASH",
      //   "description": "Lower risk, Higher reward",
      //   "multiplier": "999x",
      //   "imageUrl": "/assets/bcimages/crash.png"
      // },
      // {
      //   "id": "crash-trenball",
      //   "title": "CRASH TRENBALL",
      //   "description": "",
      //   "imageUrl": "/assets/images/hellogames/hello2.webp"
      // },

      // {
      //   "id": "keno",
      //   "title": "KENO",
      //   "description": "",
      //   "imageUrl": "/assets/bcimages/keno.png"
      // },
      // {
      //   "id": "hash-dice",
      //   "title": "HASH-DICE",
      //   "description": "",
      //   "imageUrl": "/assets/bcimages/hashdice.png"
      // },
      // {
      //     id: "Limbo",
      //     title: "Limbo",
      //     description: "",
      //     imageUrl: "/assets/bcimages/limbo.png",
      //   },
      // {
      //   "id": "hilo",
      //   "title": "HILO",
      //   "description": "",
      //   "imageUrl": "/assets/bcimages/hilo.png"
      // },
      // {
      //   "id": "blackjack",
      //   "title": "BLACKJACK",
      //   "description": "",
      //   "imageUrl": "/assets/bcimages/blackjack.png"
      // },

      // {
      //   "id": "singlekeno",
      //   "title": "SINGLEKENO",
      //   "description": "",
      //   "imageUrl": "/assets/bcimages/singleKeno.png"
      // },
      // {
      //   "id": "goal",
      //   "title": "GOAL",
      //   "description": "",
      //   "imageUrl": "/assets/bcimages/goal.png"
      // },
      // {
      //   "id": "videopoker",
      //   "title": "VIDEOPOKER",
      //   "description": "",
      //   "imageUrl": "/assets/bcimages/videopoker.png"
      // },
      // {
      //   "id": "3-card-monte",
      //   "title": "3-CARD-MONTE",
      //   "description": "",
      //   "imageUrl": "/assets/bcimages/3-card-monte.png"
      // },
      // {
      //   "id": "tower",
      //   "title": "TOWER",
      //   "description": "",
      //   "imageUrl": "/assets/bcimages/tower.avif"
      // },
      // {
      //   "id": "diamond",
      //   "title": "DIAMOND",
      //   "description": "",
      //   "imageUrl": "/assets/bcimages/diamond.jpg"
      // },



      // {
      //   "id": "ultimate-dice",
      //   "title": "ULTIMATE DICE",
      //   "description": "",
      //   "multiplier": "9900x",
      //   "imageUrl": "/assets/images/hellogames/hello4.webp"
      // },
      // {
      //   "id": "oriental-beauties",
      //   "title": "ORIENTAL BEAUTIES",
      //   "description": "",
      //   "imageUrl": "/assets/images/hellogames/hello1.webp"
      // },
      // {
      //   "id": "classic-dice",
      //   "title": "CLASSIC DICE",
      //   "description": "Easy to win like a real casino",
      //   "imageUrl": "/assets/bcimages/classicDice.png"
      // },
      // {
      //   "id": "plinko",
      //   "title": "PLINKO",
      //   "description": "",
      //   "multipliers": ["2.1x", "0.5x", "420x"],
      //   "imageUrl": "/assets/bcimages/plinko.png"
      // },
      // {
      //   "id": "cave-of-plunder",
      //   "title": "CAVE OF PLUNDER",
      //   "description": "",
      //   "imageUrl": "/assets/images/hellogames/hello4.webp"
      // },
      // {
      //   "id": "wheel",
      //   "title": "WHEEL",
      //   "description": "",
      //   "multipliers": ["39.6x", "49.50x", "19.8x"],
      //   "imageUrl": "/assets/bcimages/wheel.png"
      // },
      // {
      //   "id": "saviour-sword",
      //   "title": "SAVIOUR SWORD",
      //   "description": "",
      //   "imageUrl": "/assets/images/hellogames/hello2.webp"
      // },
      // {
      //   "id": "mine",
      //   "title": "MINE",
      //   "description": "",
      //   "imageUrl": "/assets/images/hellogames/hello3.webp"
      // },
      // {
      //   "id": "ultimate-dice",
      //   "title": "ULTIMATE DICE",
      //   "description": "",
      //   "multiplier": "9900x",
      //   "imageUrl": "/assets/images/hellogames/hello4.webp"
      // },
    ]
    const Livecasinogames = [{
      "id": "crash",
      "title": "CRASH",
      "description": "Lower risk, Higher reward",
      "multiplier": "999x",
      "imageUrl": "/assets/bcimages/liveCasino/9e20f4796d.png"
    },
    {
      "id": "crash-trenball",
      "title": "CRASH TRENBALL",
      "description": "",
      "imageUrl": "/assets/bcimages/liveCasino/8838b65d2f.png"
    },
    {
      "id": "mine",
      "title": "MINE",
      "description": "",
      "imageUrl": "/assets/bcimages/liveCasino/9225fb579c.png"
    },
    {
      "id": "ultimate-dice",
      "title": "ULTIMATE DICE",
      "description": "",
      "multiplier": "9900x",
      "imageUrl": "/assets/bcimages/liveCasino/0486468943.png"
    },
    {
      "id": "oriental-beauties",
      "title": "ORIENTAL BEAUTIES",
      "description": "",
      "imageUrl": "/assets/bcimages/liveCasino/a9a19e4edd.png"
    },
    {
      "id": "classic-dice",
      "title": "CLASSIC DICE",
      "description": "Easy to win like a real casino",
      "imageUrl": "/assets/bcimages/liveCasino/cbe377c8e7.png"
    },
    {
      "id": "plinko",
      "title": "PLINKO",
      "description": "",
      "multipliers": ["2.1x", "0.5x", "420x"],
      "imageUrl": "/assets/bcimages/liveCasino/daceae6b5f.png"
    },
    {
      "id": "cave-of-plunder",
      "title": "CAVE OF PLUNDER",
      "description": "",
      "imageUrl": "/assets/bcimages/liveCasino/ecd2996efc.png"
    },
    {
      "id": "wheel",
      "title": "WHEEL",
      "description": "",
      "multipliers": ["39.6x", "49.50x", "19.8x"],
      "imageUrl": "/assets/bcimages/liveCasino/ff32d4ec06.png"
    }
      // {
      //   "id": "saviour-sword",
      //   "title": "SAVIOUR SWORD",
      //   "description": "",
      //   "imageUrl": "/assets/images/hellogames/hello2.webp"
      // },
      // {
      //   "id": "mine",
      //   "title": "MINE",
      //   "description": "",
      //   "imageUrl": "/assets/images/hellogames/hello3.webp"
      // },
      // {
      //   "id": "ultimate-dice",
      //   "title": "ULTIMATE DICE",
      //   "description": "",
      //   "multiplier": "9900x",
      //   "imageUrl": "/assets/images/hellogames/hello4.webp"
      // },
    ]
    const slotsGames = [{
      "id": "crash",
      "title": "CRASH",
      "description": "Lower risk, Higher reward",
      "multiplier": "999x",
      "imageUrl": "/assets/bcimages/slots/446c7ecc52.jpg"
    },
    {
      "id": "crash-trenball",
      "title": "CRASH TRENBALL",
      "description": "",
      "imageUrl": "/assets/bcimages/slots/803ec99667.png"
    },
    {
      "id": "mine",
      "title": "MINE",
      "description": "",
      "imageUrl": "/assets/bcimages/slots/3758_Sweet Bonanza.png"
    },
    {
      "id": "ultimate-dice",
      "title": "ULTIMATE DICE",
      "description": "",
      "multiplier": "9900x",
      "imageUrl": "/assets/bcimages/slots/8289_Mahjong Ways.png"
    },
    {
      "id": "oriental-beauties",
      "title": "ORIENTAL BEAUTIES",
      "description": "",
      "imageUrl": "/assets/bcimages/slots/12159_Money Coming (1).png"
    },
    {
      "id": "classic-dice",
      "title": "CLASSIC DICE",
      "description": "Easy to win like a real casino",
      "imageUrl": "/assets/bcimages/slots/8333_Wild Bandito.png"
    },
    // {
    //   "id": "plinko",
    //   "title": "PLINKO",
    //   "description": "",
    //   "multipliers": ["2.1x", "0.5x", "420x"],
    //   "imageUrl": "/assets/bcimages/slots/12159_Money Coming.png"
    // },
    {
      "id": "cave-of-plunder",
      "title": "CAVE OF PLUNDER",
      "description": "",
      "imageUrl": "/assets/bcimages/slots/12538_Wild Bounty Showdown.avif"
    },
    {
      "id": "wheel",
      "title": "WHEEL",
      "description": "",
      "multipliers": ["39.6x", "49.50x", "19.8x"],
      "imageUrl": "/assets/bcimages/slots/15490_Ultra Wheel.png"
    },
    {
      "id": "saviour-sword",
      "title": "SAVIOUR SWORD",
      "description": "",
      "imageUrl": "/assets/bcimages/slots/8311_Mahjong Ways 2.png"
    },
      // {
      //   "id": "mine",
      //   "title": "MINE",
      //   "description": "",
      //   "imageUrl": "/assets/images/hellogames/hello3.webp"
      // },
      // {
      //   "id": "ultimate-dice",
      //   "title": "ULTIMATE DICE",
      //   "description": "",
      //   "multiplier": "9900x",
      //   "imageUrl": "/assets/images/hellogames/hello4.webp"
      // },
    ]

    // Games are fetched dynamically from backend — no env var filtering needed


    return (
      <div style={{ width: "100%" }}>
        {this._isMounted &&
          <>
            <Helmet>
              <title>{getBrand()}</title>
            </Helmet>

            {/* Page Content */}
            {content}

            <div style={{
              marginTop: '10px'
            }}>
              <HomeHeroSection>
                <HeroLeft>
                  {isAuthed ? (
                    <div className="w-full">
                      <h2 className="text-lg font-bold text-white mb-2 flex items-center gap-2" style={{ textTransform: "capitalize", marginTop: "-8px" }}>
                        <span style={{ width: "6px", height: "24px", borderRadius: "99px", backgroundColor: "#559cfc", display: "inline-block" }} />
                        Your VIP Progress
                      </h2>
                      {/* Outer Card */}
                      <div 
                        style={{ 
                          background: "#0E1D24",
                          borderRadius: "6px",
                          padding: "16px",
                          border: "1px solid rgba(255, 255, 255, 0.05)",
                          boxShadow: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)",
                          height: isMobileView ? "auto" : "176px"
                        }}
                      >
                        {/* Inner Progress Card */}
                        <div 
                          style={{
                            maxWidth: "448px",
                            height: "100%",
                            borderRadius: "6px",
                            border: "1px solid rgba(255, 255, 255, 0.08)",
                            padding: "20px 24px",
                            backgroundColor: "#112127",
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between"
                          }}
                        >
                          <div>
                            {/* Username Row with Next Level inline on the right */}
                            <div className="flex items-center justify-between w-full">
                              <button 
                                className="flex items-center gap-1 text-white font-bold"
                                style={{ border: "none", background: "none", cursor: "pointer", padding: 0 }}
                              >
                                {storage.getKey("name") || "Player"} <ChevronRight size={16} style={{ color: "#559cfc" }} />
                              </button>
                              
                              {(()=>{
                                const { vipLevelNum, vipLevels } = this.props;
                                const sorted = [...(vipLevels||[])].sort((a,b)=>a.level_number-b.level_number);
                                const nxt = sorted.find(l=>l.level_number>(vipLevelNum||0));
                                if (!nxt) return null;
                                return (
                                  <span style={{ fontSize: '11px', color: '#8e969f' }}>
                                    Next level: <strong style={{ color: '#fff' }}>{nxt.level_name}</strong>
                                  </span>
                                );
                              })()}
                            </div>
                                                         {(()=>{
                               const { vipLevelNum, totalWageredUsd, totalDepositUsd, vipLevels } = this.props;
                               if (!vipLevels || vipLevels.length === 0) {
                                 return (
                                   <div style={{ color: '#8e969f', fontSize: '11px', marginTop: '12px' }}>
                                     Loading VIP Progress...
                                   </div>
                                 );
                               }

                               const sorted = [...vipLevels].sort((a,b)=>a.level_number-b.level_number);
                               const cur = sorted.find(l=>l.level_number===vipLevelNum)||sorted[0];
                               const nxt = sorted.find(l=>l.level_number>(vipLevelNum||0));

                               const formatUSD = (val) => {
                                 const num = Number(val) || 0;
                                 return new Intl.NumberFormat('en-US', {
                                   style: 'currency',
                                   currency: 'USD',
                                   minimumFractionDigits: num % 1 === 0 ? 0 : 2,
                                   maximumFractionDigits: 2
                                 }).format(num);
                               };

                               if (!cur || !nxt) {
                                 return (
                                   <div className="flex justify-between items-center w-full text-sm text-white font-bold" style={{ marginTop: "12px" }}>
                                     <span>100.00%</span>
                                     <div style={{ fontSize: '12px', color: '#8e969f' }}>🏆 Max Level Reached</div>
                                   </div>
                                 );
                               }

                               const isBoth = nxt.condition_type === 'both';

                               if (isBoth) {
                                  // Calculate separate percentages
                                  const toWager = parseFloat(nxt.required_amount || 0);
                                  const wagerPct = toWager > 0 ? Math.min(100, Math.max(0, (totalWageredUsd / toWager) * 100)) : 0;

                                  const toDep = parseFloat(nxt.required_deposit || nxt.required_amount || 0);
                                  const depPct = toDep > 0 ? Math.min(100, Math.max(0, (totalDepositUsd / toDep) * 100)) : 0;

                                  return (
                                     <div style={{ marginTop: '14px', width: '100%' }}>
                                       {/* Side-by-side Progress Bars Grid */}
                                       <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                         {/* Wager Block */}
                                         <div style={{ background: 'rgba(255,255,255,0.02)', padding: '10px 12px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.04)' }}>
                                           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                                             <span style={{ fontSize: '11px', color: '#8e969f', fontWeight: 'bold', textTransform: 'uppercase' }}>Wager</span>
                                             <span style={{ fontSize: '11px', color: '#559cfc', fontWeight: 'bold' }}>{wagerPct.toFixed(1)}%</span>
                                           </div>
                                           <div style={{ width: '100%', backgroundColor: '#1b2c38', height: '4px', borderRadius: '99px', overflow: 'hidden' }}>
                                             <div style={{ height: '100%', width: `${wagerPct}%`, backgroundColor: '#559cfc', transition: 'width 0.6s ease' }} />
                                           </div>
                                           <div style={{ fontSize: '10px', color: '#559cfc', marginTop: '6px', fontWeight: '600' }}>
                                             {formatUSD(totalWageredUsd)} / {formatUSD(toWager)}
                                           </div>
                                         </div>

                                         {/* Deposit Block */}
                                         <div style={{ background: 'rgba(255,255,255,0.02)', padding: '10px 12px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.04)' }}>
                                           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                                             <span style={{ fontSize: '11px', color: '#8e969f', fontWeight: 'bold', textTransform: 'uppercase' }}>Deposit</span>
                                             <span style={{ fontSize: '11px', color: '#24ee89', fontWeight: 'bold' }}>{depPct.toFixed(1)}%</span>
                                           </div>
                                           <div style={{ width: '100%', backgroundColor: '#1b2c38', height: '4px', borderRadius: '99px', overflow: 'hidden' }}>
                                             <div style={{ height: '100%', width: `${depPct}%`, backgroundColor: '#24ee89', transition: 'width 0.6s ease' }} />
                                           </div>
                                           <div style={{ fontSize: '10px', color: '#24ee89', marginTop: '6px', fontWeight: '600' }}>
                                             {formatUSD(totalDepositUsd)} / {formatUSD(toDep)}
                                           </div>
                                         </div>
                                       </div>
                                     </div>
                                   );
                                }

                                // Single progress bar flow
                                const isDeposit = nxt.condition_type === 'deposit';
                                const currentVal = isDeposit ? totalDepositUsd : totalWageredUsd;
                                const to = parseFloat(isDeposit ? (nxt.required_deposit || nxt.required_amount || 0) : (nxt.required_amount || 0));
                                const pct = to > 0 ? Math.min(100, Math.max(0, (currentVal / to) * 100)) : 0;

                               return (
                                 <div style={{ width: '100%' }}>
                                   <div 
                                     ref={this.vipInfoRef}
                                     onMouseEnter={() => this.setState({ showVipInfo: true })}
                                     onMouseLeave={() => this.setState({ showVipInfo: false })}
                                     className="flex items-center gap-2 text-sm text-white font-bold relative"
                                     style={{ marginTop: "12px", width: "fit-content", cursor: "pointer" }}
                                   >
                                     <span>{pct.toFixed(2)}%</span>
                                     <button
                                       onClick={() => this.setState({ showVipInfo: !this.state.showVipInfo })}
                                       className="text-gray-400 hover:text-white"
                                       style={{ border: "none", background: "none", cursor: "pointer", padding: 0, display: "flex", alignItems: "center" }}
                                       aria-label="VIP info"
                                     >
                                       <Info size={16} />
                                     </button>
                                     {this.state.showVipInfo && (
                                       <div 
                                         className="absolute left-0 top-7 z-20 w-[320px] max-w-[80vw] rounded-md bg-[#0f212e] border border-gray-800 shadow-xl p-3 text-[13px] font-normal text-gray-300 leading-relaxed"
                                         style={{ border: "1px solid rgba(255,255,255,0.05)", textAlign: "left" }}
                                       >
                                         <div 
                                           className="absolute -top-1.5 left-16 w-3 h-3 rotate-45 bg-[#0f212e]" 
                                           style={{ borderLeft: "1px solid rgba(255,255,255,0.05)", borderTop: "1px solid rgba(255,255,255,0.05)" }}
                                         />
                                         {window?.siteConfig?.vip_tooltip_text || `All settled sports and racing bets contribute progress at 3x. Casino bets contribute progress at 1x, except Only on SevenX games, which contribute progress at 2x. Voided bets do not count.`}
                                       </div>
                                     )}
                                   </div>
                                   <div style={{ width: '100%', backgroundColor: '#1E2D35', height: '6px', borderRadius: '9999px', overflow: 'hidden', marginTop: '8px' }}>
                                     <div style={{ height: '100%', width: `${pct}%`, backgroundColor: '#559cfc', borderRadius: '9999px', transition: 'width 0.6s ease' }} />
                                   </div>
                                   <div className="flex justify-end items-center mt-3 text-sm text-gray-400">
                                     <span style={{ fontSize: '12px' }}>{isDeposit ? 'Dep: ' : 'Wager: '}{formatUSD(currentVal)} / {formatUSD(to)}</span>
                                   </div>
                                 </div>
                               );
                             })()}
                           </div>
                         </div>
                       </div>
                     </div>
                  ) : (
                    <>
                       <HeroTitle dangerouslySetInnerHTML={{ __html: window?.siteConfig?.home_hero_title || `The World's <span>#1 Casino</span> <br /> & Sportsbook` }} />
                       <HeroSubtitle>
                         {window?.siteConfig?.home_hero_subtitle || "Experience world-class gaming with exclusive rewards."}
                       </HeroSubtitle>
                       <HeroActions>
                         <RegisterBtn to="/register">
                           Register Now
                         </RegisterBtn>
                         
                         {(() => {
                           const socialLogins = [];
                           const authConfig = this.state.authConfig;
                           if (!authConfig || authConfig.google?.visible !== false) {
                             socialLogins.push({ l: "G", c: "#fff", t: "#000", action: () => window.location.href = `${API}/api/auth/google` });
                           }
                           if (!authConfig || authConfig.facebook?.visible !== false) {
                             socialLogins.push({ l: "F", c: "#1877f2", t: "#fff", action: () => window.location.href = `${API}/api/auth/facebook` });
                           }
                           if (!authConfig || authConfig.kick?.visible !== false) {
                             socialLogins.push({ l: "K", c: "#53fc18", t: "#000", action: () => window.location.href = `${API}/api/auth/kick` });
                           }
                           
                           if (socialLogins.length === 0) return null;
                           
                           return (
                             <>
                               <Divider />
                               <div style={{ display: "flex", gap: "8px" }}>
                                 {socialLogins.map((b, index) => (
                                   <SocialBtn key={index} onClick={b.action} style={{ cursor: 'pointer' }}>
                                     <SocialIconSpan style={{ background: b.c, color: b.t }}>
                                       {b.l}
                                     </SocialIconSpan>
                                   </SocialBtn>
                                 ))}
                               </div>
                             </>
                           );
                         })()}
                       </HeroActions>
                     </>
                  )}
                </HeroLeft>

                <HeroRight>
                  {(() => {
                    const banner1 = this.state.banners[0];
                    const img1 = banner1 && banner1.image_url
                      ? (banner1.image_url.startsWith('http') ? banner1.image_url : `${API}${banner1.image_url}`)
                      : sweet;
                    const link1 = banner1 ? (banner1.link_url || banner1.button_link) : "/casino";
                    const title1 = banner1 ? (banner1.heading || "Casino") : "Casino";
                    const count1 = banner1 && banner1.subheading ? banner1.subheading : "50,251";
                    
                    const IconComponent1 = banner1 && banner1.tag && LucideIcons[banner1.tag]
                      ? LucideIcons[banner1.tag]
                      : Spade;

                    const banner2 = this.state.banners[1];
                    const img2 = banner2 && banner2.image_url
                      ? (banner2.image_url.startsWith('http') ? banner2.image_url : `${API}${banner2.image_url}`)
                      : sugar;
                    const link2 = banner2 ? (banner2.link_url || banner2.button_link) : "/sports";
                    const title2 = banner2 ? (banner2.heading || "Sports") : "Sports";
                    const count2 = banner2 && banner2.subheading ? banner2.subheading : "37,967";

                    const IconComponent2 = banner2 && banner2.tag && LucideIcons[banner2.tag]
                      ? LucideIcons[banner2.tag]
                      : Trophy;

                    return (
                      <>
                        <CategoryCard to={link1}>
                          <CardImage src={img1} alt="Casino" />
                          <CardOverlay />
                          <CardFooter>
                            <CardTitle>
                              {React.createElement(IconComponent1, { size: 16, style: { color: "#559cfc" } })}
                              {title1}
                            </CardTitle>
                            <CardCount>
                              <LiveDot />
                              {count1}
                            </CardCount>
                          </CardFooter>
                        </CategoryCard>

                        <CategoryCard to={link2}>
                          <CardImage src={img2} alt="Sports" />
                          <CardOverlay />
                          <CardFooter>
                            <CardTitle>
                              {React.createElement(IconComponent2, { size: 16, style: { color: "#559cfc" } })}
                              {title2}
                            </CardTitle>
                            <CardCount>
                              <LiveDot />
                              {count2}
                            </CardCount>
                          </CardFooter>
                        </CategoryCard>
                      </>
                    );
                  })()}
                </HeroRight>
              </HomeHeroSection>

              {/* <NewCarousel>
                <SwiperSlider/>
              </NewCarousel> */}
              {/* <BannerGames/> */}


              {/* Search Bar matching exactly with Casino.js */}
              <div className="casino-container" style={{ paddingTop: "5px" }}>
                <div className="search-container">
                  <img
                    src="/assets/bcimages/Casino/svgexport-1 (1).svg"
                    alt="search"
                    className="search-icon"
                  />
                  <input
                    type="text"
                    placeholder="Search your favorite games"
                    className="search-input"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && e.target.value) {
                        window.location.href = '/casino/all-casino-game?search=' + encodeURIComponent(e.target.value);
                      }
                    }}
                  />
                </div>
              </div>

              <GamesWrapper>

                {/* {activeItem === 'Original' && (
                  <div style={{ margin: '12px', }}>
                    <Games t={t} games={BCoriginal} />
                  </div>
                )} */}


                {/* {
                  activeItem === 'Lobby' && (
                    <div style={{ marginTop: '12px' }}>
                      <Games t={t} games={BCoriginal} />
                    </div>

                  )
                } */}

                {
                  activeItem === "Slots" && (
                    <Swiper
                      spaceBetween={20}
                      loop={true}
                      slidesPerView={9}
                      autoplay={{
                        delay: 100,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                      }}
                      modules={[Autoplay]}
                      className="mySwiper"
                      breakpoints={{
                        180: {
                          slidesPerView: 2,
                        },
                        210: {
                          slidesPerView: 3,
                        },
                        260: {
                          slidesPerView: 4,
                        },
                        345: {
                          slidesPerView: 5,
                        },
                        390: {
                          slidesPerView: 5,
                        },
                        490: {
                          slidesPerView: 6,
                        },
                        590: {
                          slidesPerView: 8,
                        },
                        768: {
                          slidesPerView: 7,
                        },
                        840: {
                          slidesPerView: 8,
                        },
                        1000: {
                          slidesPerView: 10,
                        },
                        1200: {
                          slidesPerView: 13,
                        },
                        1600: {
                          slidesPerView: 14,
                        },
                      }}
                    >
                      {/* {slotsGames.map((game, index) => (
                        <SwiperSlide key={index}>
                          <GridItemSlots>
                            <SlotImages src={game.imageUrl} alt={game.title} />
                          </GridItemSlots>
                          <Title style={{ fontSize: "clamp(5px,3vw,7px)", whiteSpace: "nowrap" }}>{game.title}</Title>
                        </SwiperSlide>
                      ))} */}
                    </Swiper>
                  )
                }

                {
                  activeItem === "Live Casino" && (
                    <Swiper
                      spaceBetween={20}
                      loop={true}
                      slidesPerView={9}
                      autoplay={{
                        delay: 100,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                      }}
                      modules={[Autoplay]}
                      className="mySwiper"
                      breakpoints={{
                        180: {
                          slidesPerView: 2,
                        },
                        210: {
                          slidesPerView: 3.3,
                        },
                        260: {
                          slidesPerView: 4,
                        },
                        345: {
                          slidesPerView: 5,
                        },
                        390: {
                          slidesPerView: 5,
                        },
                        490: {
                          slidesPerView: 6,
                        },
                        590: {
                          slidesPerView: 8,
                        },
                        768: {
                          slidesPerView: 7,
                        },
                        840: {
                          slidesPerView: 8,
                        },
                        1000: {
                          slidesPerView: 10,
                        },
                        1200: {
                          slidesPerView: 13,
                        },
                        1600: {
                          slidesPerView: 14,
                        },
                      }}
                    >
                      {games.map((game, index) => (
                        <SwiperSlide key={index}>
                          <GridItemSlots>
                            <SlotImages src={game.imageUrl} alt={game.title} />
                          </GridItemSlots>
                          <Title style={{ fontSize: "clamp(5px,3vw,7px)", whiteSpace: "nowrap" }}>{game.title}</Title>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  )
                }


              </GamesWrapper>



              {/* <GamesSlotWrapper>
                <GamesSwiper gameData={GamesData} category="hot-games"/>
              </GamesSlotWrapper>

              <GamesSlotWrapper>
                <GamesSwiper gameData={GamesData} category="live-casino"/>
              </GamesSlotWrapper>

              <GamesSlotWrapper>
                <GamesSwiper gameData={GamesData} category="spribe"/>
              </GamesSlotWrapper>

              <GamesSlotWrapper>
               <GamesSwiper gameData={GamesData} category="Evolution"/>
              </GamesSlotWrapper>



               <GamesSlotWrapper>
               <GamesSwiper gameData={GamesData} category="Ezugi"/>
              </GamesSlotWrapper>

              <GamesSlotWrapper>
               <GamesSwiper gameData={GamesData} category="games/Slots"/>
              </GamesSlotWrapper>*/}

              {/* <GamesSlotWrapper>
               <GamesSwiper gameData={GamesData} category="games/Sports"/>
              </GamesSlotWrapper>  */}



              <br />


              {this.props.groups && this.props.groups
                .filter((group) => group.show_on_home_casino)
                .map((group) => (
                  <DynamicGroupSwiper
                    key={group.id}
                    group={group}
                    prefix="/casino/group/"
                  />
                ))}

              {/* bc original */}




              <GamesSlotWrapper style={{ display: "none" }}>
                <div>
                  <div className="lottery-text" style={{ fontSize: '17px', fontWeight: 'bold', marginLeft: "15px", display: "flex", flex: "nowrap" }}>
                    Upcoming Lottery Draw
                  </div>

                </div>

                <AllButtonRigthTitleContainer style={{ marginTop: "12px" }}>
                  {/* <AllButtonTopTitleContainer onClick={this.handleShowAllClick}>{showAll ? 'All' : 'All'}</AllButtonTopTitleContainer> */}
                  <div style={{ display: 'flex', gap: '4px', alignItems: 'right' }}>

                    <PaginationButtonLottery style={{ marginRight: "60px" }} >
                      <ChevronLeft size={20} className="swiper-button-prev" />
                    </PaginationButtonLottery>
                    <PaginationButtonLottery  >
                      <ChevronRight size={20} className="swiper-button-next" />


                    </PaginationButtonLottery>
                  </div>
                </AllButtonRigthTitleContainer>

                <div>
                  <UpcomingLottery />
                </div>

              </GamesSlotWrapper>



              {/* Filtered Games Display */}
              {searchQuery && (
                <Card className="brd7">
                  <Card.Body className={this.state.padding}>
                    <h4 className="mt-2 mb-2 section-title"> Search Results</h4>
                    <div className="d-flex w-full" style={{ overflow: 'hidden', flexWrap: 'wrap' }}>
                      <div style={{
                        display: 'flex',
                        flexWrap: isMobileView ? 'nowrap' : 'wrap',
                        width: '100%',
                        overflowX: isMobileView ? 'scroll' : 'hidden', // Enable horizontal scroll for mobile view
                        WebkitOverflowScrolling: 'touch', // for smooth scrolling on mobile
                        msOverflowStyle: 'none', // hide scrollbar in IE and Edge
                        scrollbarWidth: 'none', // hide scrollbar in Firefox
                      }}>
                        {filteredGamesEvolution.concat(filteredGamesPragmatic, filteredGamesEvoplay, filteredGamesGenisis, filteredGamesPgsoft, filtergamespragamaticlive,).map((game, index) => (
                          <div key={game.game_code} onClick={() => this.handleGameLaunch(game.game_code, game.provider_code)} style={{ marginRight: index % 5 === 4 ? '0' : isMobileView ? '10px' : '25px', marginLeft: '3px' }}>
                            <img src={game.banner} style={{ width: '150px', height: '175px', borderRadius: 10, marginBottom: '10px' }} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              )}
            </div>
          </>
        }


        <CasinoLeaderboard />

        {/* Loader */}
        {loading && (
          <div className="d-flex justify-content-center align-items-center" style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 9999 }}>
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        )}

        {/* Snackbar */}
        {message && (
          <Alert variant={message.type === 'error' ? 'danger' : 'success'} style={{ position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)', zIndex: 9999 }}>
            {message.text}
          </Alert>
        )}
      </div>
    );
  }
}

export function HomeWrapper(props) {
  const { data: groups } = useActiveGroups();
  const launchGameMutation = useGameLaunchMutation();
  const launchGameNewMutation = useGameLaunchNewMutation();

  // Fetch user VIP data
  const uid = props.cookies?.get?.('uid');
  const { data: profileData } = useMyProfileQuery(uid);
  const { data: levelsData } = useLevelQuery();

  const userProfile = profileData?.data?.[0];
  const vipLevelNum = parseInt(userProfile?.vip_level || 0, 10);
  const totalWageredUsd = parseFloat(userProfile?.total_wagered_usd || userProfile?.total_bet_amount || 0);
  const totalDepositUsd = parseFloat(userProfile?.total_deposit_amount || 0);
  const vipLevels = levelsData?.data || [];

  return (
    <Home
      {...props}
      groups={groups || []}
      launchGame={launchGameMutation.mutateAsync}
      launchGameNew={launchGameNewMutation.mutateAsync}
      vipLevelNum={vipLevelNum}
      totalWageredUsd={totalWageredUsd}
      totalDepositUsd={totalDepositUsd}
      vipLevels={vipLevels}
    />
  );
}

export default withCookies(HomeWrapper);
